import jwtDecode from "jwt-decode";
import axios from "./axios";

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    // console.log("Token expiry:", new Date(decoded.exp * 1000));
    // console.log("Current time:", new Date(currentTime * 1000));

    // Check if token is expired
    return decoded.exp > currentTime;
  } catch (error) {
    // console.error("Token validation error:", error);
    return false;
  }
};

const setSession = (accessToken) => {
  if (accessToken) {
    // console.log("✅ Setting session with token");
    localStorage.setItem("accessToken", accessToken);
    // Set default header for all axios requests
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // console.log("✅ Axios Authorization header set");
  } else {
    // console.log("❌ Clearing session");
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
